import React, { FC } from "react";
// @ts-ignore
import DateTimePicker from "react-datetime-picker";
import "react-clock/dist/Clock.css";
import "react-calendar/dist/Calendar.css";
import "react-datetime-picker/dist/DateTimePicker.css";
import { IInputProps } from "../../../modules/form";

interface IInputDateTimeProps extends IInputProps {
  minDate?: any;
  isShowTime?: boolean;
}

export const InputDateTime: FC<IInputDateTimeProps> = (props) => {
  const { value, onChange, minDate, isDisabled, isShowTime } = props;
  return (
    <DateTimePicker
      className="InputDateTime"
      calendarClassName="InputDateTimeCalendar"
      // clockClassName="InputDateTimeClock"
      onChange={onChange}
      minDate={minDate || null}
      value={value}
      locale="vi-VN"
      disabled={isDisabled}
      format={isShowTime ? "dd/MM/yyyy H:mm" : "dd/MM/yyyy"}
    />
  );
  // return <input type='datetime-local' />
};
